/**
 * The typewriter reveal.
 *
 * One of the four movements the design allows (typewriter, tile fade, caret,
 * seal press), and the only one that is not a keyframe: a line arrives a
 * character at a time, which cannot be done in CSS without knowing the width of
 * a face the glyphs may not come from.
 *
 * `prefers-reduced-motion` is respected by showing the whole line at once
 * rather than by animating it slowly. Only one line is ever being revealed, so
 * one timer is enough.
 */

const STEP_MS = 18

let handle: ReturnType<typeof setInterval> | undefined

export function stopReveal(): void {
  if (handle !== undefined) clearInterval(handle)
  handle = undefined
}

/** Reveal `text`, calling back with how much of it is on screen. */
export function reveal(text: string, reduced: boolean, onProgress: (shown: number) => void): void {
  stopReveal()
  if (reduced || text.length === 0) {
    onProgress(text.length)
    return
  }
  let shown = 0
  onProgress(0)
  handle = setInterval(() => {
    shown += 1
    onProgress(Math.min(shown, text.length))
    if (shown >= text.length) stopReveal()
  }, STEP_MS)
}
